import React from 'react';
import { FilterSection } from "@/components/ui/FilterSection";

export const InitialQuotationControlPanel = ({
  search,
  setSearch,
  filters,
  setFilters,
  onExport,
  isExporting
}) => {
  const handleSetFilters = (key, value) => {
    setFilters(prev => ({ ...prev, [key]: value }));
  };

  return (
    <div className="flex flex-col rounded-2xl overflow-hidden bg-white shadow-[0_8px_30px_rgb(0,0,0,0.04)] min-w-0 mb-4">
      <FilterSection
        search={search}
        setSearch={setSearch}
        filters={filters}
        setFilters={handleSetFilters}
        onExport={onExport}
        isExporting={isExporting}
        isAdvancedFilterInline={true}
        // statusOptions={[{ value: "initial_quotation", label: "Initial Quotation" }]}
        // statusPlaceholder="Initial Quotation"
      />
    </div>
  );
};
